module.exports = __webpack_public_path__ + "img/facebook.713d9647.svg";